var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 59,
  height: 70,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m0 0 59 35L0 70V0Z",
  fill: "#fff"
})));

export { SvgPlay as ReactComponent };
export default __webpack_public_path__ + "27cf00f8a548649918a59037231567a2.svg";